import * as tslib_1 from "tslib";
import { NgZone } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { MapsAPILoader } from "@agm/core";
import { AppComponent } from "../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../crossconcern/services/generic.services";
import { NurseryManager } from "../../../business/managers/nursery.manager";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { CLICK_EVENT, MAP_INITIAL_LATITUDE, MAP_INITIAL_LONGITUDE, MAP_STYLE, MOUSE_OUT_EVENT, MOUSE_OVER_EVENT, POLYGON_OPTIONS } from "../../../crossconcern/utilities/properties/map.properties";
import { finalize } from "rxjs/operators";
import { SPHERES_ROUTE } from "../../../crossconcern/utilities/properties/routename.property";
import { UserManager } from "../../../business/managers/user.manager";
import { DIM_BREAKPOINT_DESKTOP_WIDTH } from "../../../crossconcern/utilities/properties/base.property";
var FrontMapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FrontMapComponent, _super);
    function FrontMapComponent(appComponent, router, location, genericService, mapsAPILoader, nurseryManager, userManager, photosphereManager, activeRoute, zone, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.mapsAPILoader = mapsAPILoader;
        _this.nurseryManager = nurseryManager;
        _this.userManager = userManager;
        _this.photosphereManager = photosphereManager;
        _this.activeRoute = activeRoute;
        _this.zone = zone;
        _this.alertUtils = alertUtils;
        _this.avgLat = MAP_INITIAL_LATITUDE;
        _this.avgLong = MAP_INITIAL_LONGITUDE;
        _this.zoom = 9;
        _this.nurseryUUID = "";
        _this.spheres = [];
        _this.isSidebarOpen = true;
        _this.sidebarMode = "push";
        _this.polygons = [];
        // Array containing only the one nursery (the one with nurseryUUID)
        // Used as a frontsidebar component parameter
        _this.nurseries = [];
        _this.mapStyle = [];
        _this.mapStyle.push(MAP_STYLE);
        return _this;
    }
    FrontMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeRoute.params.subscribe(function (params) {
            _this.nurseryUUID = params.id;
        });
        this.isSidebarOpen = window.innerWidth > DIM_BREAKPOINT_DESKTOP_WIDTH;
    };
    FrontMapComponent.prototype.initDrawManager = function (map) {
        var _this = this;
        this.mapsAPILoader.load().then(function () {
            _this.SPHERE_MARKER = {
                url: "/assets/img/fogliolina.png",
                scaledSize: new google.maps.Size(35, 35)
            };
            _this.map = map;
            _this.getSpheres();
        });
    };
    FrontMapComponent.prototype.getSpheres = function () {
        var _this = this;
        this.nurseryManager.getPolygons(10000, 0, this.nurseryUUID)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (polygonList) {
            if (polygonList.polygons) {
                var _loop_1 = function (polygon) {
                    if (polygon.geofences) {
                        var latLng = [];
                        var polygonBounds_1 = new google.maps.LatLngBounds();
                        for (var _i = 0, _a = polygon.geofences; _i < _a.length; _i++) {
                            var geoFence = _a[_i];
                            latLng.push(new google.maps.LatLng(geoFence.latitude, geoFence.longitude));
                            polygonBounds_1.extend(new google.maps.LatLng(geoFence.latitude, geoFence.longitude));
                        }
                        var polygonOptions = POLYGON_OPTIONS;
                        polygonOptions.path = latLng;
                        var mapsPoly = new google.maps.Polygon(polygonOptions);
                        mapsPoly.setMap(_this.map);
                        var newPoly = {
                            pos: _this.polygons.length,
                            uuid: polygon.uuid,
                            uploaded: true,
                            polygon: mapsPoly,
                            productUUID: polygon.product ? polygon.product.uuid : null
                        };
                        google.maps.event.addListener(mapsPoly, MOUSE_OVER_EVENT, function () {
                            var language = _this.photosphereManager.getCurrentLanguage();
                            _this.polyInfo = polygon.product ? _this.getProductName(polygon.product, language) : null;
                            _this.infoWindowLat = polygonBounds_1.getCenter().lat();
                            _this.infoWindowLng = polygonBounds_1.getCenter().lng();
                            google.maps.event.trigger(_this.map, CLICK_EVENT, {
                                stop: null,
                                latLng: new google.maps.LatLng(0, 0)
                            });
                            if (_this.polyInfo !== null) {
                                _this.infoWindow.open();
                            }
                        });
                        google.maps.event.addListener(mapsPoly, MOUSE_OUT_EVENT, function () {
                            _this.infoWindow.close();
                        });
                        _this.polygons.push(newPoly);
                    }
                };
                for (var _i = 0, _a = polygonList.polygons; _i < _a.length; _i++) {
                    var polygon = _a[_i];
                    _loop_1(polygon);
                }
            }
        });
        this.photosphereManager.getPhotospheres(10000, 0, this.nurseryUUID, true)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function (sphereList) {
            if (sphereList.photospheres) {
                var lats = 0;
                var longs = 0;
                _this.nurseries.push(sphereList.photospheres[0].nursery);
                var _loop_2 = function (sphere) {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(sphere.latitude, sphere.longitude),
                        icon: _this.SPHERE_MARKER
                    });
                    marker.setMap(_this.map);
                    google.maps.event.addListener(marker, CLICK_EVENT, function () {
                        _this.goToRouteByName(SPHERES_ROUTE, { id: _this.nurseryUUID }, { start: sphere.uuid });
                    });
                    _this.spheres.push({
                        sphere: sphere,
                        marker: marker
                    });
                    lats += sphere.latitude;
                    longs += sphere.longitude;
                };
                for (var _i = 0, _a = sphereList.photospheres; _i < _a.length; _i++) {
                    var sphere = _a[_i];
                    _loop_2(sphere);
                }
                _this.avgLat = lats / sphereList.photospheres.length;
                _this.avgLong = longs / sphereList.photospheres.length;
                if (_this.nurseryUUID === "ec7f59ea-d221-44cc-9409-2034fc63b0bb") {
                    _this.zoom = 13;
                }
                else {
                    _this.zoom = 17;
                }
            }
        });
    };
    // Sidebar
    FrontMapComponent.prototype.toggleSidebar = function () {
        this.isSidebarOpen = !this.isSidebarOpen;
    };
    FrontMapComponent.prototype.refreshSidebar = function () {
        var _this = this;
        setTimeout(function () {
            _this.sidebarElement.triggerRerender();
        }, 900);
    };
    return FrontMapComponent;
}(BaseComponent));
export { FrontMapComponent };
